export const providers = {
  GOOGLE: "google",
  OUTLOOK: "outlook"
};
